import React, { useState } from "react";
import ToolTipUI from "../../../../core-components/ToolTip/ToolTipUI";
import Icon from "../../../../core-components/IconsSelector";

import * as S from "./CabListingCardHeaderStyle";

interface IListingHeader {
  t: string;
  st: string;
  img_url: string;
  c_i: Array<{
    t?: string;
    icon?: {
      t?: string;
      bc?: string;
    };
  }>;
  t_p: string;
  o_c_m: string;
  o_c_i: Array<{
    t?: string;
    icon?: {
      t?: string;
      bc?: string;
    };
  }>;
  tool_tip: string;
  cat: string;
}

const CabListingCardHeaderUI: React.FC<IListingHeader> = ({
  t = "",
  st = "",
  img_url = "",
  c_i = [],
  t_p = "",
  tool_tip = "",
  cat = ""
}) => {
  const [tooltip, setToolTip] = useState(false);
  return (
    <S.CardHeader>
      <S.CabImg src={img_url}></S.CabImg>
      <S.CabDtl>
        <div className="cabDtlhHeader">
          <div className="cabDtlhHeader">
            <h4 className="cabName">{t}</h4>
            <div className="tagText">
              <span onMouseOver={() => setToolTip(true)} onMouseOut={() => setToolTip(false)}>{st}</span>
              {tooltip ? <ToolTipUI title={`${t} ${st}`} data={tool_tip} /> : null}
            </div>
          </div>
        </div>
          <div className="cabDtlFooter">
          {cat ? <span className="cabType">{cat}</span> : null}
          {c_i?.length ? (
            <ul className="cabOfferings__list">
              {c_i.map(({ icon = '', t = '' }) => (
                <li>
                  <span>
                    {icon ? <img
                      src={icon}
                      style={{ height: '17px', paddingRight: '2px' }}
                      alt="cab amenities"
                    /> : null} 
                  </span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          ) : null}
          </div>
      </S.CabDtl>
      {t_p ?
        <S.BookedDtl>
          <p dangerouslySetInnerHTML={{ __html: t_p }}></p>
        </S.BookedDtl>
        : null}
    </S.CardHeader>
  );
};

export default CabListingCardHeaderUI;
